module.exports = __webpack_public_path__ + "static/img/28-北京市海淀北部新区实验学校(初中部).2b1c19f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/28-北京市海淀北部新区实验学校(初中部).png
// module id = IcpV
// module chunks = 0